module.exports = __webpack_public_path__ + "img/ic-arrow-n.a758c1d3.svg";